export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function lerp(a, b, t) {
  return a + (b - a) * t;
}

export function approach(current, target, dt, speed) {
  if (!dt || speed <= 0) {
    return current;
  }
  const t = 1 - Math.exp(-speed * dt);
  return current + (target - current) * t;
}

export function randomBetween(min, max) {
  return min + Math.random() * (max - min);
}

export function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function easeOutCubic(t) {
  const u = 1 - t;
  return 1 - u * u * u;
}

export function computeCoverUVs(imgWidth, imgHeight, canvasWidth, canvasHeight) {
  const canvasAspect = canvasWidth / canvasHeight;
  const imageAspect = imgWidth / imgHeight;

  let u0 = 0;
  let u1 = 1;
  let v0 = 0;
  let v1 = 1;

  if (canvasAspect > imageAspect) {
    const scale = canvasAspect / imageAspect;
    const vRange = 1 / scale;
    v0 = (1 - vRange) * 0.5;
    v1 = v0 + vRange;
  } else if (canvasAspect < imageAspect) {
    const scale = imageAspect / canvasAspect;
    const uRange = 1 / scale;
    u0 = (1 - uRange) * 0.5;
    u1 = u0 + uRange;
  }

  return new Float32Array([u0, v0, u1, v0, u0, v1, u1, v1]);
}

export function fitSpriteSize(baseSize, textureWidth, textureHeight) {
  const aspect = textureWidth / textureHeight;
  let width = baseSize * aspect;
  let height = baseSize;
  if (width > baseSize) {
    width = baseSize;
    height = baseSize / aspect;
  }
  return { width, height };
}

export function getFrameSize(textureInfo, cols, rows) {
  if (!textureInfo || !textureInfo.width || !textureInfo.height) {
    return null;
  }
  if (textureInfo.frameWidth && textureInfo.frameHeight) {
    return {
      width: textureInfo.frameWidth,
      height: textureInfo.frameHeight,
    };
  }
  return {
    width: textureInfo.width / cols,
    height: textureInfo.height / rows,
  };
}

export function getSpriteUvArray(sprite) {
  if (!sprite || !sprite.uv) {
    return new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]);
  }
  const uv = sprite.uv;
  return new Float32Array([uv.u0, uv.v0, uv.u1, uv.v0, uv.u0, uv.v1, uv.u1, uv.v1]);
}

export function getSpriteSourceSize(sprite) {
  if (!sprite) {
    return { width: 1, height: 1 };
  }
  const width = sprite.sourceWidth || sprite.width || 1;
  const height = sprite.sourceHeight || sprite.height || 1;
  return { width, height };
}

export function mapUvsToSprite(baseUvs, sprite) {
  if (!sprite || !sprite.uv) {
    return baseUvs;
  }
  const uv = sprite.uv;
  const out = new Float32Array(baseUvs.length);
  for (let i = 0; i < baseUvs.length; i += 2) {
    const u = baseUvs[i];
    const v = baseUvs[i + 1];
    out[i] = uv.u0 + (uv.u1 - uv.u0) * u;
    out[i + 1] = uv.v0 + (uv.v1 - uv.v0) * v;
  }
  return out;
}
